"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const link_1 = __importDefault(require("next/link"));
const Utils_1 = require("../../utils/Utils");
const ThemeProvider_1 = require("../../utils/ThemeProvider");
const StyleUtils_1 = require("../../utils/StyleUtils");
const RawLink = (props) => {
    const { href, disabled = false, useActiveNav = false, useRouter = true, target = '_self', styles, testId, className = '', onClick } = props, additionalProps = __rest(props, ["href", "disabled", "useActiveNav", "useRouter", "target", "styles", "testId", "className", "onClick"]);
    const { router } = (0, ThemeProvider_1.useThemeRouter)();
    const { pathname } = (0, Utils_1.parseLocation)(useRouter ? (0, ThemeProvider_1.useThemeRouter)().router : undefined);
    const dtiList = (0, Utils_1.getTestIdAttribute)(testId);
    const handleOnClick = (e) => {
        if (disabled)
            e.preventDefault();
        else if (onClick)
            onClick(e);
    };
    const active = useActiveNav && pathname === href ? styles.activeNav : '';
    return useRouter ? (router === ThemeProvider_1.RouterTypes.REACT_ROUTER ? ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, Object.assign({ to: href, target: target, "aria-disabled": disabled, className: (0, StyleUtils_1.classNames)(styles.link, active, className), onClick: handleOnClick }, dtiList, additionalProps, { children: props.children }))) : ((0, jsx_runtime_1.jsx)(link_1.default, Object.assign({ href: href, target: target, "aria-disabled": disabled, className: (0, StyleUtils_1.classNames)(styles.link, active, className), onClick: handleOnClick }, dtiList, additionalProps, { children: props.children })))) : ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: href, target: target, "aria-disabled": disabled, className: (0, StyleUtils_1.classNames)(styles.link, active, className), onClick: handleOnClick }, dtiList, additionalProps, { children: props.children })));
};
exports.RawLink = RawLink;
